(() => {
  // This asset is loaded only by the Board Library. Native collection paging
  // and filters would otherwise truncate its two-source server-rendered union.
  const libraryURL = new URL(window.location.href);
  let needsCanonicalURL = false;
  [...libraryURL.searchParams.keys()].forEach((key) => {
    if (key === 'page' || key === 'sort_by' || key.startsWith('filter.')) {
      libraryURL.searchParams.delete(key);
      needsCanonicalURL = true;
    }
  });
  if (needsCanonicalURL) {
    window.location.replace(libraryURL.toString());
    return;
  }
  if (customElements.get('nl-board-library')) return;
  const PAGE_SIZE = 24;
  const fold = (value = '') => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[’‘′]/g, "'").toLowerCase().trim();
  // Existing, reviewed maker photography from nl-surf-brand-story. These are
  // maker editorial images, never our shop's product photographs posing as brands.
  const EDITORIAL = {
    thomas: { image: 'https://www.thomassurfboards.com/cdn/shop/files/thomas-surfboards-2018-51_1500x.jpg?v=1613509328', position: '67% 50%', alt: 'Inside the Thomas Surfboards workshop', text: 'Thomas Bexon and Jake Bowrey build boards in Noosa, from traditional logs to mid-lengths and shorter shapes.', source: 'https://www.thomassurfboards.com/pages/about' },
    'donald-takayama': { image: 'https://image.jimcdn.com/app/cms/image/transf/none/path/s5fe9262bdb7f5eec/image/i9db52e4d2268440d/version/1437195004/image.jpg', position: '50% 15%', alt: 'A workshop photograph from the Hawaiian Pro Designs archive', text: 'Hawaiian Pro Designs carries forward Donald Takayama’s designs, from traditional single fins to progressive longboards and shorter shapes.', source: 'https://www.surfboardsbydonaldtakayama.com/' },
    bennett: { image: 'https://www.bennettsurf.com/cdn/shop/files/Surf_2048x2048.jpg?v=1689664804', position: '50% 25%', alt: 'Coloured boards in the Bennett board rack', text: 'Barry Bennett began the family business in 1956. Three generations of board building span traditional longboards, performance shapes and shorter boards.', source: 'https://www.bennettsurf.com/' },
    vouch: { image: 'https://vouchsurf.com/wp-content/uploads/2021/08/image0-1-bw.jpg?w=768&h=505', position: '53% 65%', alt: 'Surfers outside the Vouch workshop', text: 'Designed by Evan and Paul and built through their Byron Bay factory. Fish, hull and vee designs take different lines through the range.', source: 'https://vouchsurf.com/about/' },
    'laguna-bay': { image: 'https://noosasurfworks.com.au/cdn/shop/files/DING_REPAIRS_2048x.jpg?v=1669161584', position: '68% 40%', alt: 'A board being polished at Noosa Surf Works', text: 'Tully St. John’s longboard label, at home in Noosa Surf Works. Explore Flowmaster and Sleepwalker in our library.', source: 'https://noosasurfworks.com.au/' },
    'south-coast': { image: 'https://www.southcoastsurfboards.com/cdn/shop/files/IMG_0567_0604ebf0-19a3-48ae-9bb2-3c8de1ab47a8.jpg?crop=center&height=1200&v=1660727177&width=1200', position: '50% 50%', alt: 'A detail from the South Coast workshop', text: 'Ian Chisholm’s longboard range. Compare the Low Pro and Virtuoso models, then the dimensions and finish of each board.', source: 'https://www.southcoastsurfboards.com/pages/ian-chisholm' },
    'higher-state': { image: 'https://static.wixstatic.com/media/967537_12d9ef80a8cc47e6872b999598f95a73~mv2.jpg', position: '45% 55%', alt: 'A board being shaped at Higher State', text: 'Founded by Kai Ellice-Flint, Higher State brings 1960s longboard design into contemporary surfing. Browse Frission and Vault 66.', source: 'https://www.higherstateproductions.com/about-1' },
    dingley: { image: 'https://images.squarespace-cdn.com/content/v1/639c51ab8b97d74e8a1e4c90/91897356-301f-4921-a578-4602b9f4ae06/Fisheye+Film-34_Original.jpg?format=750w', position: '60% 45%', alt: 'A surfer with a board from the Dingley maker story', text: 'Billy Dingley began shaping in Cornwall and is now based in Noosa. Explore the Sinatra boards and their individual finishes.', source: 'https://www.dingleysurfboards.uk/about' },
    'xo-coco': { text: 'Explore the Halcyon and Tryst Fish boards in our library.' },
    'mitchell-surman': { text: 'Explore the Cinnamon Girl and Electric Lady boards in our library.' },
  };
  const TYPE_NAMES = { longboard: 'Longboards', midlength: 'Mid-lengths', 'fish-twin': 'Fish & twins', shortboard: 'Shortboards', softboard: 'Softboards' };
  const SIGNATURE_ORDER = ['firstpoint', 'littlecove', 'nationalpark', 'teatree', 'granite'];
  const modelIdentity = (card) => fold(card.dataset.modelName || card.dataset.model).replace(/[^a-z0-9]/g, '');
  const compareCards = (a, b) => {
    const department = (card) => card.dataset.maker === 'noosa-longboards' ? (card.dataset.range === 'gt' ? 1 : 0) : 2;
    const signatureRank = (card) => {
      const index = SIGNATURE_ORDER.indexOf(modelIdentity(card));
      return department(card) === 0 && index !== -1 ? index : SIGNATURE_ORDER.length;
    };
    return department(a) - department(b) || (a.dataset.makerName || '').localeCompare(b.dataset.makerName || '') || signatureRank(a) - signatureRank(b) || (a.dataset.modelName || '').localeCompare(b.dataset.modelName || '', undefined, { numeric: true }) || (a.dataset.search || '').localeCompare(b.dataset.search || '', undefined, { numeric: true });
  };
  const make = (tag, className, text) => { const element = document.createElement(tag); if (className) element.className = className; if (text) element.textContent = text; return element; };

  class BoardLibrary extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      this.scopeMaker = this.dataset.rangeScope === 'gt' ? 'noosa-longboards-gt' : '';
      this.grid = this.querySelector('[data-library-grid]');
      // Retain original product nodes across reconnects and GT choice changes.
      this.sourceCards ||= [...this.querySelectorAll('[data-library-card]')];
      this.cards = [...this.sourceCards];
      this.maker = this.querySelector('[data-library-maker]');
      this.model = this.querySelector('[data-library-model]');
      this.type = this.querySelector('[data-library-type]');
      this.search = this.querySelector('[data-library-search]');
      this.count = this.querySelector('[data-library-count]');
      this.more = this.querySelector('[data-library-more]');
      this.empty = this.querySelector('[data-library-empty]');
      this.heading = this.querySelector('[data-library-heading]');
      this.context = this.querySelector('[data-library-context]');
      if (!this.grid || !this.maker || !this.model || !this.search) return;
      this.decorateCards();

      this.cards.sort(compareCards);
      this.groupGTCards();
      const fragment = document.createDocumentFragment();
      this.cards.forEach((card) => fragment.append(card));
      this.grid.replaceChildren(fragment);
      this.makers = new Map();
      this.cards.forEach((card) => this.makers.set(card.dataset.maker, card.dataset.makerName));
      if (this.cards.some((card) => card.dataset.maker === 'noosa-longboards' && card.dataset.range === 'gt')) this.makers.set('noosa-longboards-gt', 'Noosa Longboards · GT');
      this.makerEntries = [...this.makers].sort(([a, an], [b, bn]) => {
        const rank = (key) => key === 'noosa-longboards' ? 0 : key === 'noosa-longboards-gt' ? 1 : 2;
        return rank(a) - rank(b) || an.localeCompare(bn);
      });
      this.maker.replaceChildren(new Option('All makers', ''));
      this.makerEntries.forEach(([value, label]) => this.maker.add(new Option(label, value)));
      if (this.dataset.remakeLibrary) {
        const brandNav = this.querySelector('[data-library-brand-choices]');
        [['', 'All brands'], ...this.makerEntries].forEach(([key, label]) => {
          const button = make('button', 'nlbl-brand-choice', label); button.type = 'button'; button.dataset.makerChoice = key; brandNav.append(button);
        });
      }
      this.buildNavigation();
      this.types = new Map(Object.entries(TYPE_NAMES).filter(([key]) => this.cards.some((card) => card.dataset.type === key)));
      this.buildTypes();
      this.readState();
      this.syncControls();
      this.apply(false);
      this.querySelectorAll('[data-library-enhanced]').forEach((element) => { element.hidden = false; });
      this.updateLanding();
      this.setupRemakes();
      this.more.parentElement.hidden = this.filtered.length <= this.state.shown;

      const eventOptions = { signal: this.events.signal };
      this.maker.addEventListener('change', () => this.changeMaker(this.maker.value), eventOptions);
      this.model.addEventListener('change', () => { this.state.model = this.model.value; this.resetPage(); }, eventOptions);
      this.type.addEventListener('change', () => { this.state.type = this.type.value; this.state.model = ''; this.updateModelOptions(); this.resetPage(); }, eventOptions);
      this.search.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => { this.state.q = this.search.value.trim(); this.resetPage(); }, 150);
      }, eventOptions);
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault(); clearTimeout(this.searchTimer); this.state.q = this.search.value.trim(); this.resetPage();
      }, eventOptions);
      this.querySelectorAll('[data-library-clear]').forEach((button) => button.addEventListener('click', () => {
        clearTimeout(this.searchTimer); this.state = { maker: this.scopeMaker, model: '', type: '', q: '', shown: PAGE_SIZE }; this.syncControls(); this.apply(true);
        if (button.closest('[data-library-empty]')) this.search.focus();
      }, eventOptions));
      this.more.addEventListener('click', () => {
        const nextCard = this.filtered[this.state.shown];
        this.state.shown += PAGE_SIZE; this.apply(true);
        if (nextCard) nextCard.querySelector('a').focus();
      }, eventOptions);
      window.addEventListener('popstate', () => { clearTimeout(this.searchTimer); this.readState(); this.syncControls(); this.apply(false); }, eventOptions);
    }

    setupRemakes() {
      this.addEventListener('submit', async event => {
        const form = event.target.closest('form[data-library-buy]'); if (!form) return;
        event.preventDefault(); const button = form.querySelector('button[type="submit"]'); if (button.disabled) return;
        button.disabled = true; button.setAttribute('aria-busy', 'true');
        const errors = form.parentElement.querySelector('.product-form__error-message-wrapper'); errors.hidden = true;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'This board could not be added. Please try again.');
          location.assign(form.elements.return_to.value);
        } catch (error) {
          errors.querySelector('.product-form__error-message').textContent = error.message; errors.hidden = false;
          button.disabled = false; button.removeAttribute('aria-busy');
        }
      }, { signal: this.events.signal });
      if (!this.dataset.remakeLibrary) return;
      const date = new Date(); date.setDate(date.getDate() + 42);
      const estimate = date.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Australia/Brisbane' });
      this.querySelector('[data-remake-date]').textContent = `Estimated pickup around ${estimate}.`;
      this.length = this.querySelector('[data-library-length]');
      this.sourceCards.forEach(card => {
        const title = card.querySelector('h4')?.textContent || '';
        const match = title.match(/(\d{1,2})\s*['’′]\s*(\d{1,2})?/);
        if (match) { const inches = Number(match[1]) * 12 + Number(match[2] || 0); card.dataset.length = inches < 84 ? 'short' : inches < 108 ? 'mid' : 'long'; }
      });
      this.querySelectorAll('[data-remake-pickup]').forEach(input => { input.value = `Around ${estimate} (approximately six weeks)`; });
      this.length.value = this.state.length || '';
      this.apply(false);
      this.length.addEventListener('change', () => { this.state.length = this.length.value; this.resetPage(); }, { signal: this.events.signal });

    }

    disconnectedCallback() {
      this.events?.abort();
      clearTimeout(this.searchTimer);
      this.initialized = false;
    }

    matchesMaker(card, key) {
      if (!card) return false;
      if (!key) return true;
      if (key === 'noosa-longboards-gt') return card.dataset.maker === 'noosa-longboards' && card.dataset.range === 'gt';
      return card.dataset.maker === key;
    }

    decorateCards() {
      this.cards.forEach((card) => {
        const copy = card.querySelector('.nlbl-card__copy');
        if (!copy) return;
        let metadata = copy.querySelector('[data-library-card-meta]');
        if (!metadata) {
          metadata = make('span', 'nlbl-card__model');
          metadata.dataset.libraryCardMeta = '';
          const maker = copy.querySelector('.nlbl-card__maker');
          if (maker) maker.after(metadata); else copy.prepend(metadata);
        }
        metadata.textContent = [card.dataset.modelName, TYPE_NAMES[card.dataset.type]].filter(Boolean).join(' · ');
        metadata.hidden = !metadata.textContent;
      });
    }

    groupGTCards() {
      const models = new Map();
      this.cards.forEach((card) => {
        if (card.dataset.maker !== 'noosa-longboards' || card.dataset.range !== 'gt' || !['gtfish', 'gtmidlength', 'gtlongboard'].includes(modelIdentity(card))) return;
        if (!models.has(card.dataset.model)) models.set(card.dataset.model, []);
        models.get(card.dataset.model).push(card);
      });
      const replacements = new Map();
      models.forEach((choices, model) => {
        // If any original cannot be represented faithfully, keep this entire
        // model as individual cards. Never hide a product to repair its data.
        if (choices.length < 2 || choices.some((card) => {
          const link = card.querySelector('.nlbl-card__link');
          const image = link?.querySelector('img');
          return !card.dataset.id || !link?.getAttribute('href') || !image?.getAttribute('src') || !link.querySelector('h4')?.textContent.trim() || !link.querySelector('.nlbl-card__price')?.textContent.trim() || card.dataset.type !== choices[0].dataset.type;
        })) return;
        const group = choices[0].cloneNode(false);
        group.classList.add('nlbl-card--choices');
        group.dataset.libraryGtGroup = '';
        group.dataset.search = choices.map((card) => card.dataset.search).join(' ');
        group.nlLibraryChoices = choices;
        group.nlLibraryChoiceIndex = -1;
        const picker = make('div', 'nlbl-card__picker');
        const label = make('label', '', 'Size / finish');
        const select = make('select');
        select.id = `NLBoardChoice-${this.id || 'Library'}-${model}-${choices[0].dataset.id}`;
        label.htmlFor = select.id;
        select.setAttribute('aria-label', `${group.dataset.modelName}: choose size or finish`);
        choices.forEach((card, index) => {
          const title = card.querySelector('h4').textContent.trim();
          const detail = title.replace(/^(?:NL\s+|Noosa\s+Longboards\s+)?GT\s*(?:Longboard|Mid[\s-]*Length|Fish)\s*[-–—:]?\s*/i, '') || title;
          const price = card.querySelector('.nlbl-card__price').textContent.trim();
          const option = new Option(`${detail} · ${price}`, String(index));
          option.dataset.descriptionPresent = card.dataset.descriptionPresent; option.dataset.boardId = card.dataset.id; option.dataset.boardTitle = title;
          select.add(option);
        });
        const note = make('span', 'nlbl-card__choice-count', `${choices.length} board choices`);
        const status = make('span', 'visually-hidden');
        status.dataset.libraryChoiceStatus = '';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-atomic', 'true');
        picker.append(label, select, note, status);
        const details = make('div', 'nlbl-card__details');
        details.append(picker);
        group.append(details);
        group.nlLibraryDetails = details;
        group.nlLibraryPicker = select;
        select.addEventListener('change', () => this.selectGTChoice(group, Number(select.value), true), { signal: this.events.signal });
        this.selectGTChoice(group, 0);
        choices.forEach((card) => replacements.set(card, card === choices[0] ? group : null));
      });
      this.cards = this.cards.flatMap((card) => replacements.has(card) ? (replacements.get(card) ? [replacements.get(card)] : []) : [card]);
    }

    selectGTChoice(group, index, announce = false) {
      const choice = group.nlLibraryChoices?.[index];
      if (!choice || group.nlLibraryChoiceIndex === index) return;
      const link = choice.querySelector('.nlbl-card__link').cloneNode(true);
      const mediaLink = link.cloneNode(false);
      mediaLink.className = 'nlbl-card__media-link';
      // The adjacent title/price link is the single keyboard stop for this
      // product. The photograph remains a clickable link to the same product.
      mediaLink.setAttribute('tabindex', '-1');
      mediaLink.append(link.querySelector('.nlbl-card__image'));
      {
        const oldForm = group.querySelector('.nlbl-buy');
        const giftSize = oldForm?.querySelector('[name="properties[Included GT boardshorts size]"]')?.value;
        const newForm = choice.querySelector('.nlbl-buy')?.cloneNode(true);
        if (oldForm) oldForm.remove();
        if (newForm) {
          const giftSelect = newForm.querySelector('[name="properties[Included GT boardshorts size]"]');
          if (giftSelect && Array.from(giftSelect.options).some((option) => option.value === giftSize)) giftSelect.value = giftSize;
          const estimate = this.querySelector('[data-remake-date]')?.textContent.replace('Estimated pickup around ', '').replace(/\.$/, '');
          if (estimate && newForm.querySelector('[data-remake-pickup]')) newForm.querySelector('[data-remake-pickup]').value = `Around ${estimate} (approximately six weeks)`;
          group.nlLibraryDetails.append(newForm);
        }
      }
      const currentMedia = group.querySelector('.nlbl-card__media-link');
      if (currentMedia) currentMedia.replaceWith(mediaLink); else group.prepend(mediaLink);
      const current = group.nlLibraryDetails.querySelector('.nlbl-card__link');
      if (current) current.replaceWith(link); else group.nlLibraryDetails.prepend(link);
      group.dataset.id = choice.dataset.id;
      group.nlLibraryChoiceIndex = index;
      group.nlLibraryPicker.value = String(index);
      this.updateGTImageSize(group);
      if (announce) group.querySelector('[data-library-choice-status]').textContent = `Selected ${choice.querySelector('h4').textContent.trim()}, ${choice.querySelector('.nlbl-card__price').textContent.trim()}`;
    }

    updateGTImageSize(card) {
      if (!card.nlLibraryChoices) return;
      const layout = this.grid.dataset.gtLayout;
      const sizes = layout === 'single' ? '(max-width: 749px) 92vw, 50vw' : layout === 'models' ? '(max-width: 749px) 42vw, 33vw' : '(max-width: 749px) 46vw, (max-width: 1099px) 30vw, 23vw';
      card.querySelector('img')?.setAttribute('sizes', sizes);
    }

    jumpToResults() { this.heading.focus({ preventScroll: true }); this.heading.scrollIntoView({ block: 'start', behavior: 'auto' }); }

    buildNavigation() {
      const own = this.querySelector('[data-library-own-models]');
      const gt = this.querySelector('[data-library-gt-models]');
      const other = this.querySelector('[data-library-other-makers]');
      own.replaceChildren(); gt.replaceChildren(); other.replaceChildren();
      const models = new Map();
      this.cards.filter((card) => card.dataset.maker === 'noosa-longboards').forEach((card) => { if (!models.has(card.dataset.model)) models.set(card.dataset.model, card); });
      models.forEach((card, key) => {
        const button = make('button', 'nlbl-model-choice'); button.type = 'button';
        button.dataset.modelChoice = key; button.dataset.choiceMaker = card.dataset.range === 'gt' ? 'noosa-longboards-gt' : 'noosa-longboards';
        const photo = card.querySelector('img')?.cloneNode();
        if (photo) { photo.alt = ''; photo.loading = 'lazy'; photo.sizes = '(max-width: 749px) 150px, 220px'; button.append(photo); }
        const title = make('span', '', card.dataset.modelName); title.append(make('span', 'nlbl-choice-arrow', '')); button.append(title);
        button.addEventListener('click', () => { this.state.maker = button.dataset.choiceMaker; this.state.model = key; this.state.type = ''; this.state.q = ''; this.syncControls(); this.resetPage(); this.jumpToResults(); }, { signal: this.events.signal });
        (card.dataset.range === 'gt' ? gt : own).append(button);
      });
      this.makerEntries.filter(([key]) => !key.startsWith('noosa-longboards')).forEach(([key, label]) => {
        const editorial = EDITORIAL[key] || {};
        const button = make('button', `nlbl-other-maker${editorial.image ? '' : ' nlbl-other-maker--name'}`); button.type = 'button'; button.dataset.makerChoice = key;
        if (editorial.image) button.append(this.editorialImage(editorial));
        const name = make('span', 'nlbl-other-maker__name', label); name.append(make('span', 'nlbl-choice-arrow', '')); button.append(name); other.append(button);
      });
      this.querySelectorAll('[data-maker-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => { this.state.type = ''; this.search.value = ''; this.changeMaker(button.dataset.makerChoice); this.jumpToResults(); }, { signal: this.events.signal });
      });
    }

    editorialImage(editorial) {
      const image = make('img'); image.src = editorial.image; image.alt = editorial.alt; image.loading = 'lazy'; image.width = 800; image.height = 600; image.style.objectPosition = editorial.position; return image;
    }

    buildTypes() {
      const section = this.querySelector('[data-library-type-section]');
      const track = this.querySelector('[data-library-types]'); track.replaceChildren();
      section.hidden = this.types.size === 0;
      this.types.forEach((label, key) => {
        const button = make('button', 'nlbl-type-choice'); button.type = 'button'; button.dataset.typeChoice = key;
        // Types are categories, not models. Keep them typographic so a GT board
        // cannot imply that it represents the whole mid-length category.
        const title = make('span', '', label); title.append(make('span', 'nlbl-choice-arrow', '')); button.append(title);
        button.addEventListener('click', () => { this.state = { maker: '', model: '', type: key, q: '', shown: PAGE_SIZE }; this.syncControls(); this.apply(true); this.jumpToResults(); }, { signal: this.events.signal });
        track.append(button);
      });
    }

    readState() {
      const params = new URL(window.location.href).searchParams;
      const maker = params.has('library_maker') ? params.get('library_maker') : this.dataset.initialMaker;
      const model = params.has('library_model') ? params.get('library_model') : this.dataset.initialModel;
      const shown = Number.parseInt(params.get('library_shown'), 10);
      this.state = {
        maker: this.scopeMaker || (this.makers.has(maker) ? maker : ''),
        model: model && model !== 'all' ? model : '',
        type: this.types.has(params.get('library_type')) ? params.get('library_type') : '',
        length: ['short','mid','long'].includes(params.get('library_length')) ? params.get('library_length') : '',
        q: (params.get('library_q') || '').slice(0, 200),
        shown: Number.isFinite(shown) ? Math.max(PAGE_SIZE, Math.min(shown, this.cards.length)) : PAGE_SIZE,
      };
      this.needsStateURL = !!params.get('library_type') && !this.state.type;
    }

    syncControls() {
      this.maker.value = this.state.maker;
      this.search.value = this.state.q;
      const lengthControl = this.querySelector('[data-library-length]'); if (lengthControl) lengthControl.value = this.state.length || '';
      this.updateTypeOptions();
      this.updateModelOptions();
    }

    updateTypeOptions() {
      const available = new Map([...this.types].filter(([key]) => this.cards.some((card) => this.matchesMaker(card, this.state.maker) && card.dataset.type === key)));
      this.type.replaceChildren(new Option('All types', ''));
      available.forEach((label, key) => this.type.add(new Option(label, key)));
      if (this.state.type && !available.has(this.state.type)) { this.state.type = ''; this.needsStateURL = true; }
      this.type.value = this.state.type;
      this.querySelector('[data-library-type-field]').hidden = available.size === 0;
    }

    updateModelOptions() {
      const models = new Map();
      this.cards.filter((card) => this.matchesMaker(card, this.state.maker) && (!this.state.type || card.dataset.type === this.state.type)).forEach((card) => {
        if (card.dataset.model && !models.has(card.dataset.model)) models.set(card.dataset.model, card);
      });
      this.model.replaceChildren(new Option('All models', ''));
      [...models].sort(([, a], [, b]) => compareCards(a, b)).forEach(([value, card]) => this.model.add(new Option(card.dataset.modelName, value)));
      if (this.state.model && !models.has(this.state.model)) { this.state.model = ''; this.needsStateURL = true; }
      this.model.value = this.state.model;
    }

    changeMaker(maker) {
      clearTimeout(this.searchTimer);
      this.state.maker = maker; this.state.model = ''; this.state.q = this.search.value.trim();
      this.syncControls(); this.resetPage();
    }

    resetPage() { this.state.shown = PAGE_SIZE; this.apply(true); }

    apply(updateURL) {
      const terms = fold(this.state.q).split(/\s+/).filter(Boolean);
      this.filtered = this.cards.filter((card) => {

        if (!this.matchesMaker(card, this.state.maker) || (this.state.type && card.dataset.type !== this.state.type) || (this.state.model && card.dataset.model !== this.state.model)) return false;
        const matches = (choice) => (!this.state.length || choice.dataset.length === this.state.length) && terms.every((term) => fold(choice.dataset.search).includes(term));
        if (!card.nlLibraryChoices) return matches(card);
        const index = card.nlLibraryChoices.findIndex(matches);
        if (index === -1) return false;
        if (!matches(card.nlLibraryChoices[card.nlLibraryChoiceIndex])) this.selectGTChoice(card, index);
        return true;
      });
      if (this.dataset.remakeLibrary) this.state.shown = this.filtered.length;
      const visible = new Set(this.filtered.slice(0, this.state.shown));
      this.cards.forEach((card) => { card.hidden = !visible.has(card); });
      const gtOnly = visible.size > 0 && [...visible].every((card) => card.dataset.range === 'gt' && card.nlLibraryChoices);
      this.grid.dataset.gtLayout = gtOnly ? (visible.size === 1 ? 'single' : 'models') : '';
      this.grid.dataset.gtCount = gtOnly ? String(visible.size) : '';
      visible.forEach((card) => this.updateGTImageSize(card));
      this.buildResultGroups(visible);
      this.updateContext();
      this.updateLanding();
      this.count.textContent = visible.size === this.filtered.length ? `${visible.size} ${visible.size === 1 ? 'result' : 'results'}` : `Showing ${visible.size} of ${this.filtered.length} results`;
      this.empty.hidden = this.filtered.length !== 0;
      this.more.parentElement.hidden = visible.size >= this.filtered.length;
      this.more.textContent = `Show ${Math.max(0, Math.min(PAGE_SIZE, this.filtered.length - visible.size))} more results`;
      this.querySelectorAll('[data-maker-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.makerChoice === this.state.maker)));
      this.querySelectorAll('[data-model-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.modelChoice === this.state.model && this.matchesMaker(this.cards.find((card) => card.dataset.model === button.dataset.modelChoice), this.state.maker))));
      this.querySelectorAll('[data-type-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.typeChoice === this.state.type)));
      if (updateURL || this.needsStateURL) {
        const url = new URL(window.location.href);
        url.searchParams.set('library_maker', this.state.maker || 'all');
        url.searchParams.set('library_model', this.state.model || 'all');
        if (this.state.type) url.searchParams.set('library_type', this.state.type); else url.searchParams.delete('library_type');
        if (this.state.length) url.searchParams.set('library_length', this.state.length); else url.searchParams.delete('library_length');
        if (this.state.q) url.searchParams.set('library_q', this.state.q); else url.searchParams.delete('library_q');
        if (this.state.shown > PAGE_SIZE) url.searchParams.set('library_shown', String(this.state.shown)); else url.searchParams.delete('library_shown');
        history.replaceState(history.state, '', url);
        this.needsStateURL = false;
      }
    }

    buildResultGroups(visible) {
      this.grid.querySelectorAll('[data-library-group]').forEach((element) => element.remove());
      let previousMaker = '';
      this.cards.filter((card) => visible.has(card)).forEach((card) => {
        const makerKey = card.dataset.range === 'gt' ? 'noosa-longboards-gt' : card.dataset.maker;
        if (makerKey !== previousMaker) {
          if (!this.state.maker || this.state.maker === 'noosa-longboards') {
          const heading = make('li', 'nlbl-group'); heading.dataset.libraryGroup = ''; heading.setAttribute('role', 'presentation');
          heading.append(make('h3', '', this.makers.get(makerKey) || card.dataset.makerName));
          this.grid.insertBefore(heading, card);
          }
          previousMaker = makerKey;
        }
      });
    }

    updateLanding() {
      if (this.dataset.remakeLibrary) {
        this.querySelectorAll('.nlbl-own, .nlbl-other, .nlbl-types, [data-library-context]').forEach(section => { section.hidden = true; });
        return;
      }
      const focused = Boolean(this.state.maker || this.state.model || this.state.type || this.state.q);
      const makerName = this.makers.get(this.state.maker);
      const modelName = this.state.model ? this.model.selectedOptions[0]?.textContent : '';
      const gt = this.state.maker === 'noosa-longboards-gt';
      const title = modelName || (gt ? 'GT / Go-To' : [makerName, TYPE_NAMES[this.state.type]].filter(Boolean).join(' / ')) || (this.state.q ? 'Search boards' : 'Board library');
      const heroTitle = this.querySelector('[data-library-hero-title]');
      if (heroTitle) heroTitle.textContent = title;
      const description = this.querySelector('[data-library-hero-description]');
      if (description) description.textContent = gt ? 'Our clean-skin range. Choose your model and length, then buy directly below. Every GT surfboard includes a pair of GT boardshorts.' : modelName ? 'Choose a size or finish, then view the board for current price and ordering options.' : focused ? 'Browse matching boards by model, size and finish.' : 'Browse by maker, model and finish.';
      const action = this.querySelector('[data-library-hero-action]');
      if (action) action.textContent = focused ? 'View boards' : 'Explore models';
      this.querySelectorAll('.nlbl-own, .nlbl-other, .nlbl-types').forEach((section) => { section.hidden = focused || (section.matches('.nlbl-types') && this.types.size === 0); });
      const browseAll = this.querySelector('[data-library-browse-all]');
      if (browseAll) browseAll.hidden = !focused;
      this.maker.closest('.nlbl-field').hidden = Boolean(this.scopeMaker);
      this.querySelectorAll('[data-library-clear]').forEach((button) => { button.textContent = this.dataset.resetLabel; });
    }

    updateContext() {
      if (this.dataset.remakeLibrary) { this.context.hidden = true; this.heading.textContent = [this.makers.get(this.state.maker), this.state.model ? this.model.selectedOptions[0]?.textContent : TYPE_NAMES[this.state.type]].filter(Boolean).join(' / ') || 'All boards'; return; }
      const makerName = this.makers.get(this.state.maker);
      const typeName = TYPE_NAMES[this.state.type];
      const modelName = this.state.model ? this.model.selectedOptions[0]?.textContent : '';
      this.heading.textContent = [makerName, modelName || typeName].filter(Boolean).join(' / ') || 'All boards';
      const editorial = EDITORIAL[this.state.maker];
      if (this.context.dataset.currentMaker === this.state.maker) return;
      this.context.dataset.currentMaker = this.state.maker; this.context.replaceChildren();
      this.context.hidden = !editorial;
      this.context.classList.toggle('nlbl-maker-context--name', !!editorial && !editorial.image);
      if (!editorial) return;
      if (editorial.image) this.context.append(this.editorialImage(editorial));
      const copy = make('div', 'nlbl-maker-context__copy'); copy.append(make('span', 'nlbl-eyebrow', 'The maker'), make('h3', '', makerName), make('p', '', editorial.text));
      if (editorial.source) { const link = make('a', 'nlbl-text-button', 'From the maker'); link.href = editorial.source; link.target = '_blank'; link.rel = 'noopener'; link.setAttribute('aria-label', `Visit ${makerName}’s official website, opens in a new window`); copy.append(link); }
      this.context.append(copy);
    }
  }
  customElements.define('nl-board-library', BoardLibrary);
})();
